export default "__VITE_ASSET__CZK0_ZUl__"